import "./homeTestimonials.css";

import ariellePic from "../../../assets/text-testimonials/arielle-testimonial-pic.webp";

const featured = {
  quote:
    "The job search is one of the most stressful things I've been through, but RAIN made it so much easier. It's all in one place: application tracking, networking help, interview prep. I finally felt like I had a real plan instead of just winging it.",
  name: "Arielle",
  role: "Summer Intern at FGS Global",
  image: ariellePic,
};

/* All three are career centers; the featured quote above is the student voice.
   Quotes are kept to a similar length so the three cards sit at matching
   heights, and `org` renders on its own line under `role` for the same
   reason — the school name never wraps up next to the job title. */
const quotes = [
  {
    quote:
      "The RAIN team is responsive, collaborative, and genuinely open to feedback. RAIN has streamlined our work behind the scenes, making it easier to support students at scale.",
    name: "Victoria Vargulick",
    role: "Director of Career Development",
    org: "Hamilton College",
    tone: "blue",
    avatar: null,
  },
  {
    quote:
      "RAIN has exceeded all expectations. It gives students a centralized way to track applications, follow a personalized task schedule, and stay on top of deadlines.",
    name: "Liz Wilson",
    role: "Assistant Director for Career Development",
    org: "Davidson College",
    tone: "teal",
    avatar: null,
  },
  {
    quote:
      "I can't think of any other tech, service, app, or platform we've ever launched that we have gotten this kind of engagement from students this quickly.",
    name: "Cassie Hagan",
    role: "Director of Professional Development",
    org: "Wabash College",
    tone: "violet",
    avatar: null,
  },
];

const initialsOf = (name) =>
  name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

/* One author row shared by the three cards, so every attribution
   below the featured quote is built the same way. */
const Author = ({ name, role, org, tone, avatar }) => (
  <footer className="home-testi-author">
    {avatar ? (
      <img decoding="async" src={avatar} alt="" className="home-testi-avatar" loading="lazy" />
    ) : (
      <span className={`home-testi-initials home-testi-initials-${tone}`} aria-hidden="true">
        {initialsOf(name)}
      </span>
    )}
    <span>
      <span className="home-testi-name">{name}</span>
      <span className="home-testi-role">{role}</span>
      {org && <span className="home-testi-org">{org}</span>}
    </span>
  </footer>
);

const HomeTestimonials = () => (
  <section className="home-testi" id="testimonials">
    <div className="home-container">
      <h2 className="home-section-title">
        Loved by students, trusted by{" "}
        <br className="br-wide" />
        the career centers behind them
      </h2>

      <div className="home-testi-featured">
        <blockquote className="home-testi-big">
          <p className="home-testi-big-quote">&ldquo;{featured.quote}&rdquo;</p>
          <footer className="home-testi-big-author">
            <span className="home-testi-name">{featured.name}</span>
            <span className="home-testi-role">{featured.role}</span>
          </footer>
        </blockquote>

        <div className="home-testi-portrait">
          <img decoding="async" src={featured.image} alt={featured.name} loading="lazy" />
        </div>
      </div>

      <div className="home-testi-grid">
        {quotes.map(({ quote, ...author }) => (
          <blockquote key={author.name} className="home-testi-card">
            <p className="home-testi-card-quote">{quote}</p>
            <Author {...author} />
          </blockquote>
        ))}
      </div>
    </div>
  </section>
);

export default HomeTestimonials;
